// 📁 src/App.js
import React, { useContext } from "react"; 
import { Routes, Route, Navigate } from "react-router-dom";
import { AuthContext } from "./context/AuthContext";
import AuthProvider from "./context/AuthContext";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import LoginPage from "./pages/LoginPage";
import UtilisateursPage from "./pages/UtilisateursPage";
import CongesPage from "./pages/CongesPage"; 
import ContratsPage from "./pages/ContratsPage";
import EmployesPage from "./pages/EmployesPage";
import RapportsPage from "./pages/RapportsPage"; 
import SalairesPage from "./pages/SalairesPage";
import CotisationRetenuGain from "./pages/CrgPage";
import Statistique from './pages/StatistiquesPage';
import VerificationPage from './pages/VerificationPage';
import PersonnelLoginPage from './pages/PersonnelLoginPage';
import PersonnelDashboard from './pages/PersonnelDashboard';
import PersonnelAdminPage from './pages/PersonnelAdminPage';
import CorbeillePage from './pages/CorbeillePage';
import DeverouillerSalairePage from './pages/DeverouillerSalairePage';
import 'bootstrap/dist/css/bootstrap.min.css';
import ImpressionDocumentsPage from './pages/ImpressionDocumentsPage';
import ParametragePage from './pages/ParametragePage';

// Composant pour protéger les routes
const ProtectedRoute = ({ children }) => {
  const { token } = useContext(AuthContext);
  
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

// Composant pour les routes publiques (comme login)
const PublicRoute = ({ children }) => {
  const { token, role } = useContext(AuthContext);
  
  if (token) {
    const r = (role || "").toUpperCase();
    if (r === "PERSONNEL") return <Navigate to="/personnel/dashboard" replace />;
    if (r === "ADMIN") return <Navigate to="/personnel-admin" replace />;
    return <Navigate to="/employes" replace />;
  }
  
  return children;
};

const AppRoutes = () => {
  return (
    <Routes>
      {/* Routes publiques */}
      <Route path="/login" element={
        <PublicRoute>
          <LoginPage />
        </PublicRoute>
      } />
      
             <Route path="/verification" element={<VerificationPage />} />
       <Route path="/personnel/login" element={<PersonnelLoginPage />} />
      
      {/* Routes protégées */}
      <Route path="/utilisateurs" element={
        <ProtectedRoute>
          <UtilisateursPage />
        </ProtectedRoute>
      } />
      
      <Route path="/employes" element={
        <ProtectedRoute>
          <EmployesPage />
        </ProtectedRoute>
      } />
      
      <Route path="/contrats" element={
        <ProtectedRoute>
          <ContratsPage />
        </ProtectedRoute>
      } />
      
      <Route path="/conges" element={
        <ProtectedRoute>
          <CongesPage />
        </ProtectedRoute>
      } />
      
      <Route path="/salaires" element={
        <ProtectedRoute>
          <SalairesPage />
        </ProtectedRoute>
      } />
      <Route path="/impressions" element={
        <ProtectedRoute>
          <ImpressionDocumentsPage />
        </ProtectedRoute>
      } />
      
      <Route path="/rapports" element={
        <ProtectedRoute>
          <RapportsPage />
        </ProtectedRoute>
      } />
      
      <Route path="/crg" element={
        <ProtectedRoute>
          <CotisationRetenuGain />
        </ProtectedRoute>
      } />
      
             <Route path="/statistiques" element={
         <ProtectedRoute>
           <Statistique />
         </ProtectedRoute>
       } />
       
       {/* Routes pour l'espace personnel */}
       <Route path="/personnel/dashboard" element={
         <ProtectedRoute>
           <PersonnelDashboard />
         </ProtectedRoute>
       } />
       <Route path="/personnel-admin" element={
         <ProtectedRoute>
           <PersonnelAdminPage />
         </ProtectedRoute>
       } />
       <Route path="/corbeille" element={
         <ProtectedRoute>
           <CorbeillePage />
         </ProtectedRoute>
       } />
       <Route path="/parametrage" element={
         <ProtectedRoute>
           <ParametragePage />
         </ProtectedRoute>
       } />
       <Route path="/deverouiller-salaire" element={
         <ProtectedRoute>
           <DeverouillerSalairePage />
         </ProtectedRoute>
       } />
      
      {/* Redirection par défaut */}
      <Route
        path="/"
        element={
          <PublicRoute>
            <Navigate to="/login" replace />
          </PublicRoute>
        }
      />
      <Route
        path="*"
        element={
          <PublicRoute>
            <Navigate to="/login" replace />
          </PublicRoute>
        }
      />
    </Routes>
  );
};

const App = () => {
  return (
    <AuthProvider>
      <AppRoutes />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </AuthProvider>
  );
};

export default App;
